import {components} from "react-select";
import type {GroupBase, MultiValueGenericProps} from "react-select";

import {Text} from "../ui/text";

import type {OptionType} from "./Select";

export function MultiValueLabel<
    Option extends OptionType,
    IsMulti extends boolean,
    Group extends GroupBase<Option>
>({children, ...props}: MultiValueGenericProps<Option, IsMulti, Group>) {
    const {data, selectProps} = props;

    return (
        <components.MultiValueLabel data={data} innerProps={{}} selectProps={selectProps}>
            <Text isTruncated color={data.isFixed ? "white" : "blueGray.800"} variant="xs">
                {children}
            </Text>
        </components.MultiValueLabel>
    );
}
